import { render, staticRenderFns } from "./material-pick-page.vue?vue&type=template&id=7fe613be&scoped=true"
import script from "./material-pick-page.vue?vue&type=script&lang=js"
export * from "./material-pick-page.vue?vue&type=script&lang=js"
import style0 from "./material-pick-page.vue?vue&type=style&index=0&id=7fe613be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe613be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe613be')) {
      api.createRecord('7fe613be', component.options)
    } else {
      api.reload('7fe613be', component.options)
    }
    module.hot.accept("./material-pick-page.vue?vue&type=template&id=7fe613be&scoped=true", function () {
      api.rerender('7fe613be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/material-pick-page.vue"
export default component.exports